import React, { ReactElement } from "react";

import FastForwardIcon from "@mui/icons-material/FastForward";

import CaloriesBurnedIcon from "../../../../../../components/Icons/CaloriesBurnedIcon";
import DistanceIcon from "../../../../../../components/Icons/DistanceIcon";
import DurationIcon from "../../../../../../components/Icons/DurationIcon";
import RepsIcon from "../../../../../../components/Icons/RepsIcon";
import SetsIcon from "../../../../../../components/Icons/SetsIcon";

interface Props {
  label: string;
}

const ExerciseFieldIcon: React.FC<Props> = ({ label }) => {
  const icons: Record<string, ReactElement> = {
    ["Duration"]: <DurationIcon fontSize="small" />,
    ["Distance"]: <DistanceIcon />,
    ["Reps"]: <RepsIcon fontSize="small" />,
    ["Sets"]: <SetsIcon />,
    ["Calories burned"]: <CaloriesBurnedIcon fontSize="small" />,
    ["Speed"]: <FastForwardIcon />,
    ["Added weight"]: <SetsIcon />,
  };

  return icons[label] ?? null;
};

export default ExerciseFieldIcon;
